import { stateOptions } from "data";

const stateAliases = stateOptions.reduce((acc, { value, label }) => {
  acc[value] = value;
  acc[label] = value;
  return acc;
}, {});

stateAliases["District of Columbia"] = "Washington DC";

const normalizeState = (state) => {
  if (!state) return "";
  const normalized = String(state).trim();
  return stateAliases[normalized] || normalized;
};

const zipPrefix = (zip) => {
  const match = String(zip ?? "").match(/\d{5}/);
  if (!match) return null;
  return Number(match[0].slice(0, 3));
};

export const stateZipCodeMapping = {
  Alabama: [[350, 369]],
  Alaska: [[995, 999]],
  Arizona: [[850, 865]],
  Arkansas: [[716, 729]],
  California: [[900, 961]],
  Colorado: [[800, 816]],
  Connecticut: [[60, 69]],
  Delaware: [[197, 199]],
  Florida: [[320, 349]],
  Georgia: [
    [300, 319],
    [398, 399],
  ],
  Hawaii: [[967, 969]],
  Idaho: [[832, 838]],
  Illinois: [[600, 629]],
  Indiana: [[460, 479]],
  Iowa: [[500, 528]],
  Kansas: [[660, 679]],
  Kentucky: [[400, 427]],
  Louisiana: [[700, 714]],
  Maine: [[39, 49]],
  Maryland: [[206, 219]],
  Massachusetts: [[10, 27]],
  Michigan: [[480, 499]],
  Minnesota: [[550, 567]],
  Mississippi: [[386, 397]],
  Missouri: [[630, 658]],
  Montana: [[590, 599]],
  Nebraska: [[680, 693]],
  Nevada: [[889, 898]],
  "New Hampshire": [[30, 38]],
  "New Jersey": [[70, 89]],
  "New Mexico": [[870, 884]],
  "New York": [[100, 149]],
  "North Carolina": [[270, 289]],
  "North Dakota": [[580, 588]],
  Ohio: [[430, 459]],
  Oklahoma: [[730, 749]],
  Oregon: [[970, 979]],
  Pennsylvania: [[150, 196]],
  "Rhode Island": [[28, 29]],
  "South Carolina": [[290, 299]],
  "South Dakota": [[570, 577]],
  Tennessee: [[370, 385]],
  Texas: [
    [733, 733],
    [750, 799],
    [885, 885],
  ],
  Utah: [[840, 847]],
  Vermont: [[50, 59]],
  Virginia: [[201, 246]],
  Washington: [[980, 994]],
  "Washington DC": [[200, 205]],
  "West Virginia": [[247, 268]],
  Wisconsin: [[530, 549]],
  Wyoming: [[820, 831]],
  "District of Columbia": [[200, 205]],
};

export const isZipCodeValidForState = (state, zip) => {
  if (!state || !zip) return true;
  const stateKey = normalizeState(state);
  const ranges = stateZipCodeMapping[stateKey];
  if (!ranges) return true;
  const prefix = zipPrefix(zip);
  if (prefix == null) return false;
  return ranges.some(([start, end]) => prefix >= start && prefix <= end);
};
